import { Component } from '@angular/core';

@Component({
  selector: 'app-doller-icon',
  templateUrl: './doller-icon.component.html',
})
export class DollerIconComponent {

}
